import AgeValidationModal, { useAgeValidationModal } from './AgeValidationModal';

export default AgeValidationModal;
export { useAgeValidationModal };
